// export interface ContainerData {
//   containersList: string[];
// }

export class FolderPatternParams {
  folderPattern?: string;
  fileName?: string

  public constructor(aFolderPattern?: string, aFileName?: string) {
    this.folderPattern = aFolderPattern;
    this.fileName = aFileName;
  }
}

export class GdriveParams {
  GdriveLink: string;

  public constructor(aGdriveLink: string) {
    this.GdriveLink = aGdriveLink;
  }
}

export class MetadataParams {
  metaDataKey: string;
  metaDataValue: string;
  folder?: string;

  public constructor(
    aMetaDataKey: string,
    aMetaDataValue: string,
    aFolder?: string
  ) {
    this.metaDataKey = aMetaDataKey;
    this.metaDataValue = aMetaDataValue;
    this.folder = aFolder;
  }
}
